<template>
  <div>
    <template v-if="!data.length > 0">
      <p>Brak danych w wybranym okresie</p>
    </template>
    <template v-else>
      <v-expansion-panels v-model="panel" multiple>
        <v-expansion-panel v-for="(article, i) in data" :key="i">
          <v-expansion-panel-header>
            Tytuł artykułu: {{ article.title }}
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-data-table
              dense
              :headers="headers"
              :items="article.article_statistics_by_month"
              item-key="name"
              calculate-widths
            >
              <template v-slot:[`item.spend_time`]="{ item }">
                <span v-if="item.spend_time">
                  {{ Math.floor(item.spend_time / 3600).toString().padStart(2, '0') }}:{{ Math.floor(item.spend_time / 60).toString().padStart(2, '0') }}:{{ Math.floor(item.spend_time % 60).toString().padStart(2, '0') }}
                </span>
              </template>
              <template v-slot:[`item.last_reading`]="{ item }">
                <span v-if="item.last_reading">
                  {{ new Date(item.last_reading).toLocaleTimeString("pl-PL") }}
                  {{ new Date(item.last_reading).toLocaleDateString("pl-PL") }}
                </span>
              </template>
              <template v-slot:[`item.percent`]="{ item }">
                <v-progress-linear
                  color="primary"
                  height="16"
                  :value="item.percent"
                  striped
                >
                  <template v-slot="{ value }">
                    <strong>{{ getScore(value) }}%</strong>
                  </template>
                </v-progress-linear>
              </template>
            </v-data-table>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </template>
  </div>
</template>
<script>
export default {
  props: {
    data: Array[Object]
  },
  data() {
    return {
      panel: [0],
      headers: [
        {
          text: "Lekarz",
          value: "doctor_name",
          width: "35%"
        },
        {
          text: "Ostatnio odświerzone",
          value: "last_reading",
          width: "20%"
        },
        {
          text: "Czas spędzony na stronie",
          value: "spend_time",
          width: "20%"
        },
        {
          text: "Przeczytane treści",
          value: "percent",
          align: "center",
          width: "25%"
        }
      ]
    };
  },
  methods: {
    getScore(val) {
      return val.toFixed(2);
    }
  }
};
</script>
